const cardTypes = {
  AI_GENERATE: 'AI_GENERATE',
  START_WITH_TEMPLATE: 'START_WITH_TEMPLATE',
};

export default cardTypes;
